module.exports = __webpack_public_path__ + "img/logo-dj.d43fbbd1.svg";